
            <button class="btn btn-link text-info d-flex align-items-center justify-content-center p-0 mb-2 font-weight-normal" [routerLink]="'../'" i18n="">
                <i class="ni ni-bold-left mr-1"></i> Back
            </button>
            <ng-container *ngIf="organization$ | async as orgnization">
                {{ orgnization.name }}
            </ng-container>
        


// WEBPACK FOOTER //
// ./src/app/access-management/organizations/organization-roles-list/organization-roles-list.component.html